import React, { Component } from 'react';
import axios from 'axios';
import {API_URL} from '../../constants';
import {formatLimitString} from '../../functions';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';

import Opinion from './opinion';

export default class OtrosSectores extends Component {

    constructor(props) {
        super(props);
        this.state = { 
            resource: [],
            response: [],
            error: [],
            key: 0,
            clave: this.props.clave,
            title: this.props.titulo,
            hasSector: false,
            hasOpinion: false,
            sectionOpinion: false
          }
      }

    callSections()
    {
        var key = this.props.clave;
        const url = `${API_URL}SectionUX/${key}`;
        axios.get(url).then(response => response.data)
        .then((data) => {
            var section = data.result.filter(item=> item.sTitulo==='Opinión y Casos de Estudio' && item.bIsAdded);
            
            if (!(section===undefined || section.length===0)) 
            {
                this.setState({ sectionOpinion: true });
            }
        })
        .catch(error => {
            console.log(error);
        });
    }

    componentDidMount() {
        this.callSections();
        var code = 'NOTI';
        var key = this.props.clave;
        var url = `${API_URL}BulletinResourceUX/${key}/${code}`; 
        axios.get(url).then(response => response.data)
        .then((data) => {
            data.result =data.result.filter(item => item.cRec_Id===9);
            this.setState({ resource: data.result });            
            document.getElementById('loaderSector').classList.add('loader--hide');
            document.getElementById('contentSector').removeAttribute("hidden");
        })
        .catch(error => {
        });
        
    }

    renderSwitch(param, show) {
        var key = this.props.clave;
        if (show) {
          switch(param) {
            case 'Opinion':
              return <Opinion clase={this.state.cssClass} clave={key} titulo={param} ></Opinion>;
          }
        }
      }    

    render() {
        return ( 
            <div className="boletin__section">
                <div className="row">
                    <div className={((this.state.sectionOpinion)?("col-sm-6"):("col-sm-12"))}>
                        <ul id="boletin__header-title">
                            <li className="boletin__subtitle-name ">
                                 <span className="boletin__subtitle-name--pl">{this.state.title}</span>
                            </li>
                        </ul>
                        <div className="row last-news-sector__secundary-row">
                        <div className="loaderSector"></div>
                        {this.state.resource.map((resource, index) => (
                            <div  className={((this.state.sectionOpinion)?("last-news-sector__secundary col-sm-6"):("last-news-sector__secundary col-sm-3"))}  hidden={false} id="contentSector" key={resource.nBoletinRecursoCodigo}>
                                 <Link to={'/' + this.props.clave + '/' + resource.nRecursoCodigo} className="new-opportunity__more-info-link">
                                <div className="last-news-sector__secundary-item" >
                                    <p className={"last-news__category last-news__category--"+this.props.clase}>TENDENCIAS</p>
                                    <p className="last-news-sector__secundary-item-title">  {formatLimitString(resource.sTituloRecurso, 70)} </p>
                                    <p className="last-news-sector__secundary-item-extract"> {formatLimitString(resource.sResumenRecurso, 60)} </p>
                                    <p className="last-news-sector__more-info">
                                   
                                        <span className="last-news-sector__more-info-arrow">
                                        <i className="fas fa-chevron-right"></i>
                                        </span>
                                    
                                    </p>
                                </div>
                                </Link>
                            </div>
                            ))}
                        </div>
                    </div>
                    <div className="col-sm-6" hidden={!this.state.sectionOpinion}>
                        <Opinion clave={this.props.clave}></Opinion>
                    </div>
                </div>
            </div>
        )
    }

}